"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
const useStyles = exports.useStyles = (0, _core.makeStyles)({
  labelButton: {
    background: 'transparent',
    border: 0,
    outline: 0,
    color: 'rgba(0, 0, 0, 0.6)',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 600,
    textDecoration: 'underline'
  },
  labelButtonDisabled: {
    color: 'rgba(0, 0, 0, 0.3)',
    cursor: 'default'
  }
});